module.exports = __webpack_public_path__ + "static/itsm_capabilities_3_2-208d7abfa4e76c63237a58b4e58bbc3b.png";